import React, {memo} from "react";
import styles from "./styles.module.scss";
import {TextMedium14} from "@/app/components/texts";

interface Props {
  icon: React.ReactNode;
  text: string | number;
}

const UserSmallData: React.FC<Props> = ({icon, text}) => {
  return (
    <div className={styles.userSmallData}>
      {icon}
      <TextMedium14 text={text.toString()} className={styles.text}/>
    </div>
  );
};

export default memo(UserSmallData);